const wowApp = require('angular').module('wowApp.common');
wowApp.service('olyFormValidationSummaryService', [require('./form-validation-summary-service')]);
wowApp.directive('olyFormValidationSummary', ['olyFormValidationSummaryService', '$timeout', require('./form-validation-summary-directive')]);
wowApp.directive('olyFormValidationSummaryDisplay', ['olyFormValidationSummaryService', 'MoveFocus', require('./form-validation-summary-display-directive')]);


/** WEBPACK FOOTER **
 ** ./wowapp/src/common/components/form-validation-summary/index.js
 **/